import styles from './grid.module.scss';

export const Container = ({ children }) => <div className={styles.container}>{children}</div>;
